import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectFilteredReturns, selectReturnFilterStatuses } from '../../store/selectors';
import { ReturnsList } from '../index';

export default () => {
  const returnStatuses = useSelector(selectReturnFilterStatuses(false));
  const [selectedStatus, setSelectedStatus] = useState(returnStatuses[0]);

  return (
    <ReturnsList
      returnStatuses={returnStatuses}
      selectedStatus={selectedStatus}
      setSelectedStatus={setSelectedStatus}
    />
  );
};
